module.exports = __webpack_public_path__ + "static/media/RP-48.69028887.pdf";